module.exports = __webpack_public_path__ + "img/SDG-goals.20438558.png";